<template>
  <div style="width: 100%;height:100%;">
    <v-app-bar app flat height="50" color="#1E3A8A">
      <img src="../../../assets/top_bar/logoAndTitleNew.png" style="width:220px;flex:none;margin-right:14px;" />
    </v-app-bar>
    <div style="width: 100%;height:100%;display: flex;align-items: center;justify-content: center;">
      <!--找回密码card-->
      <v-card class="card" style="width: 400px;height: 520px;">
        <div style="color:rgba(0, 0, 0, 1);font-size: 24px;float: left;line-height: 24px;font-weight: 400;">找回密码</div>
        <!--内容-->
        <div style="width: 280px;margin: 0 auto;">
          <!--手机验证码-->
          <div v-show="step===1" style="margin-top: 85px">
            <v-form
                    ref="phoneForm"
                    v-model="isInputValid">
              <v-text-field
                  @input="onPhoneChanged"
                  placeholder="请输入手机账号"
                  v-model="phoneNum"
                  :rules = "phoneRule"
                  required>
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入正确的手机格式</div>
                </template>
                <template v-slot:prepend-inner>
                  <div @click.stop="showPhoneCode = true"  style="cursor: pointer;display: flex">
                    <div style="width: fit-content;line-height: 25px;color:black;" >+{{prefix}}</div>
                    <v-icon color="black">mdi-menu-down</v-icon>
                  </div>
                </template>
              </v-text-field>
              <div v-show="phoneNotRegistered" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;该手机号尚未注册绑定</div>
            </v-form>
            <input-pic-captcha :prefix="prefix" :phone="phoneNum"></input-pic-captcha>
            <v-text-field
                placeholder="请输入手机验证码"
                autocomplete="off"
                v-model="verificationCode"
                class="input-group--focused"
                :rules = "requiredRule"
                border="none">
              <template v-slot:message>
                <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;验证码不能为空</div>
              </template>
              <template v-slot:append>
                <div  @click="sendMsg()" style="width: max-content;cursor: pointer;padding-top: 5px;padding-right: 1px" :style="{color:sendingAvailable ?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
              </template>
            </v-text-field>
            <div v-show="loginVerifyCodeLock" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px;text-align:right;" >操作频繁，请1分钟后再试</div>
            <div v-show="loginVerifyCodeError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码有误，请重新输入</div>

            <!--下一步按键-->
            <v-btn
                @click="step1"
                width="280px"
                height="40px"
                depressed
                :color="phoneLoginBtnClickable?'rgba(25, 118, 210, 1)':'rgba(25, 118, 210, 0.5)'"
                style="left: 50%;transform: translateX(-50%);position: absolute;bottom: 130px;color: white;font-size: 16px">
              下一步</v-btn>
            <!--区号-->
            <phone-code class="phoneCode" v-show="showPhoneCode" @selectPhoneCode="selectPhoneCode"></phone-code>
          </div>
          <!--设置新密码-->
          <div v-show="step===2" style="margin-top: 85px">
            <v-form ref="newPasswordForm"
                    v-model="isNewPasswordValid">
              <v-text-field
                  placeholder="请输入新密码"
                  v-model="newPassword"
                  :rules="passwordRules"
                  :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNewPassword ? 'text' : 'password'"
                  class="input-group--focused"
                  @click:append="showNewPassword = !showNewPassword">
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;密码为6-16个字符，且包含数字和字母及特殊字符</div>
                </template>
              </v-text-field>
              <v-text-field
                  placeholder="确认输入新密码"
                  v-model="newPassword2"
                  :rules="password2Rules"
                  :append-icon="showNewPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNewPassword2 ? 'text' : 'password'"
                  class="input-group--focused"
                  @click:append="showNewPassword2 = !showNewPassword2">
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;两次密码不一致</div>
                </template>
              </v-text-field>
            </v-form>
            <v-btn
                @click="step2"
                width="280px"
                height="40px"
                depressed
                :color="isNewPasswordValid?'rgba(25, 118, 210, 1)':'rgba(25, 118, 210, 0.5)'"
                style="left: 50%;transform: translateX(-50%);position: absolute;bottom: 150px;color: white;font-size: 16px">
              完成</v-btn>
          </div>
          <!--设置新密码成功-->
          <div v-show="step===3" style="width: 100%;height: 350px;display: flex;align-items: center;justify-content: center;">
            <div style="width: max-content;height: 40px">
              <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>
              <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">密码修改成功</div>
            </div>
          </div>
        </div>
      </v-card>
      <Vcode :show="showPicVerify" @success="onPicVerifySuccess" @close="closePicVerify" successText="验证成功！"
             failText="验证失败，请重试！"/>
    </div>
  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode";
import PhoneCode from "@/components/user_system/PhoneCode";
import InputPicCaptcha from "@/components/user_system/InputPicCaptcha";
import utils from "@/utils/utils";

export default {
  name: "RetrievePassword",
  components: {
    PhoneCode,InputPicCaptcha,
    Vcode,
  },
  mounted() {
    window.clearInterval(this.clock); //关闭
  },
  data(){
    return {
      phoneNum:'',
      prefix:'86',
      showPhoneCode:false,
      countDownClock:null,
      verificationCode:'',
      step:1,
      email:'',
      phoneNotRegistered:false,
      loginVerifyCodeLock:false,
      loginVerifyCodeError:false,
      picVerifyCode:'',
      emailVerifyCode:'',
      sendAgain:false,
      picVerifyCodeError:false,
      mailVerifyCodeError:false,
      newPassword:'',
      newPassword2:'',
      showNewPassword:false,
      showNewPassword2:false,
      isNewPasswordValid:true,
      isInputValid:false,
      ///验证码倒计时
      sendingAvailable:true,
      countDownNum:60,
      sendCodeContent:'获取验证码',
      showPicCount:0,
      showPicVerify: false,
      picVerifySuccess:false,
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneRule:[
        v => (this.prefix === "86" ? v.length === 11 : !!v) || 'phone must be valid',
      ],
      requiredRule:[
        v => !!v || 'E-mail is required',
      ],
      passwordRules:utils.passwordRules,
      password2Rules:[
        v => !!v || 'Name is required',
        v => (v && v === this.newPassword ) || "1"
      ],
    }
  },
  computed:{
    phoneLoginBtnClickable(){
      return (this.prefix === "86" ? this.phoneNum.length === 11 : !!this.phoneNum) && !!this.verificationCode
    },
    phoneValid(){
      return (this.prefix === "86" ? this.phoneNum.length === 11 : !!this.phoneNum)
    },
  },
  methods:{
    onPhoneChanged(){
      this.phoneNotRegistered = false
    },
    async checkPhoneExist(){
      if(!this.phoneLoginBtnClickable){
        return
      }
      this.loginVerifyCodeError = false
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      let resultData = await this.$axios.get('/userApi/existPhone',{
        params:{
          "phone": this.phoneNum,
        }
      })
      return resultData.data.data
    },
    selectPhoneCode(code){
      this.prefix = code
      console.log(this.prefix)
      this.showPhoneCode = false
    },
    sendMsg(){
      if(!this.sendingAvailable || !this.phoneValid){
        this.$refs.phoneForm.validate()
        return
      }
      if(this.$store.state.picCaptcha === ""){
        this.$store.state.picCaptchaError = true;
        return;
      }
      let formData = new FormData()
      formData.append('phone',this.phoneNum)
      formData.append('prefix',"+" + this.prefix)
      formData.append('picCaptcha',this.$store.state.picCaptcha)
      formData.append( 'purpose','modifyPassword')
      this.$axios.post('/userApi/sendCodeForAction',formData).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.code === 4015){
          this.$store.state.picCaptchaError = true;
        }
        else if(resultData.code === 4014){
          this.loginVerifyCodeLock = true;
          setTimeout(()=>{
            this.loginVerifyCodeLock = false;
          },3000)
        }
        else{
          this.sendingAvailable = false
          this.countDownClock = window.setInterval(() => {
            this.countDownNum--;
            this.sendCodeContent = "重新发送（"+this.countDownNum+')'
            if (this.countDownNum < 0) {
              //当倒计时小于0时清除定时器
              window.clearInterval(this.countDownClock); //关闭
              this.sendingAvailable = true;
              this.countDownNum = 60;
              this.sendCodeContent = "获取验证码"
            }
          }, 1000);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    async checkCodeEarth(){
      if(!this.phoneLoginBtnClickable){
        return
      }
      this.loginVerifyCodeError = false
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      let resultData = await this.$axios.get('/userApi/checkCodeEarth',{
        params:{
          "captcha": this.verificationCode,
          "phone": this.phoneNum,
          "prefix": "+" + this.prefix,
          "device": "web",
          "purpose": "modifyPassword",
          "site": "earth"
        }
      })
      return resultData
    },
    async step1() {
      this.picVerifyCodeError = false
      this.phoneNotRegistered = false
      if (this.showPicCount >= 3 && !this.picVerifySuccess) {
        this.showPicVerify = true
        return
      }
      // 格式校验
      if (!this.isInputValid) {
        this.$refs.phoneForm.validate()
        return
      }
      let isExist = await this.checkPhoneExist()
      console.log(isExist)
      if (isExist) {
        let resultData = await this.checkCodeEarth()
          if (resultData.data.code === 200) {
            window.localStorage.setItem('authorToken',resultData.data.token)
            this.step = 2

          }else{
            this.loginVerifyCodeError = true
            this.showPicCount = this.showPicCount + 1
            this.picVerifySuccess = false
          }
      } else {
        this.phoneNotRegistered = true
        this.showPicCount = this.showPicCount + 1
        this.picVerifySuccess = false
        this.picVerifyCode = ''
      }
    },
    step2(){
      if(!this.isNewPasswordValid){
        this.$refs.newPasswordForm.validate()
        return
      }
      // 修改密码
      let formData = new FormData();
      formData.append('password',this.newPassword);
      this.$axios.post('/userApi/modifyPassword',formData).then(
          (resultData)=>{
            if(resultData.data.code === 200){
              this.step = 3
              this.jumpToLogin()
            }
          }
      )
    },


   async nextStep(){
     this.picVerifyCodeError = false
     this.phoneNotRegistered = false
     if(this.step === 1){
       if(this.showPicCount >= 3 && !this.picVerifySuccess){
         this.showPicVerify = true
         return
       }
       // 格式校验
       if(!this.isInputValid){
         this.$refs.phoneForm.validate()
         return
       }

       if(this.picVerifyCode !== this.$refs.pVerify.imgCode){
         this.picVerifyCodeError = true
         this.$refs.pVerify.handleDraw()
         return
       }

       let data = new FormData()
       data.append('email',this.email)
       let resultData = await this.$axios.post('/userApi/creator/isCreatorExit',data)
       if(resultData.data.data){
         let _this = this
         let formData = new FormData()
         formData.append('email',this.email)
         formData.append('purpose','modifyPassword')
         this.$axios.post('/userApi/creator/sendEmailCode', formData).then((resultData)=>{
           if(resultData.data.code === 200){
             _this.step = 2
           }
         })
       }else{
         this.phoneNotRegistered = true
         this.showPicCount = this.showPicCount + 1
         this.picVerifySuccess = false
         this.picVerifyCode = ''
         this.$refs.pVerify.handleDraw()
       }
     }else if(this.step === 2){
       if(this.showPicCount >= 3 && !this.picVerifySuccess){
         this.showPicVerify = true
         return
       }
       // 验证邮箱验证码
       this.$axios.get('/userApi/creator/checkCode',{
         params:{
           "email":this.email,
           "captcha":this.emailVerifyCode,
           "purpose":'modifyPassword'
         }
       }).then(
           (resultData)=>{
             if(resultData.data.code === 200&&resultData.data.data){
               this.step = 3
             }else{
               // 验证码输入错误3次后，弹出图形验证码
               this.mailVerifyCodeError = true
               this.showPicCount = this.showPicCount + 1
               this.picVerifySuccess = false
             }
           }
       )
     }else if(this.step === 3){
       // 修改密码
       this.$axios.get('/userApi/creator/updatePassword',{
         params:{
           "email":this.email,
           "password":this.newPassword
         }
       }).then(
           (resultData)=>{
             if(resultData.data.code === 200){
               this.step = 4
               this.jumpToLogin()
             }
           }
       )
     }
    },
    sendEmail(){
     if(!this.sendingAvailable){
       return
     }
      this.sendingAvailable = false
      let formData = new FormData()
      formData.append('email',this.email)
      formData.append( 'purpose','findPassword')
      this.$axios.post('/userApi/creator/sendEmailCode',formData)
      window.clearInterval(this.clock); //关闭
      this.countDownNum = 60;
      let clock = window.setInterval(() => {
        this.countDownNum--;
        this.sendCodeContent = "重新发送（"+this.countDownNum+')'
        if (this.countDownNum < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock); //关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "重新发送"
        }
      }, 1000);
    },
    // 用户通过了验证
    onPicVerifySuccess(msg) {
      this.showPicVerify = false;
      this.showPicCount = 2
      this.picVerifySuccess = true
      // 通过验证后，需要手动隐藏模态框
    },
    // 用户点击遮罩层，应该关闭模态框
    closePicVerify() {
      this.showPicVerify = false;
    },
    jumpToLogin(){
      let _this = this
      setTimeout(function () {
        _this.$router.push({
          name: 'earthLogin',
          query:{
            "currentCard":"loginCard",
            'way':"account"
          }
        })
      },2000);
    }
  },
  watch:{
    picVerifyCode(){
      if(this.picVerifyCode === ''){
        this.picVerifyCodeError = false
      }

    }
  }
}
</script>

<style scoped>
  .card{
    padding:35px 45px 10px 45px;
    width: 100%;
    height: 100%
  }
  /*各浏览器提示文本样式*/
  input::-webkit-input-placeholder { /* WebKit browsers */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
</style>
